import React, { useState, useEffect, useRef } from 'react';
import Captcha from './Captcha';
import apiService from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';

const ModalCandidatura = ({ isOpen, onClose, onNotification }) => {
  const { t } = useLanguage();

  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    ddi: '+245',
    telefone: '',
    cargo: '',
    experiencia: '',
    disponibilidade: '',
    motivacao: '',
    cv: null,
    foto: null
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [isDdiDropdownOpen, setIsDdiDropdownOpen] = useState(false);
  const [ddiSearch, setDdiSearch] = useState('');
  const ddiDropdownRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleTelefoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove tudo que não é dígito
    setFormData(prev => ({
      ...prev,
      telefone: value
    }));
  };

  const ddiOptions = [
    { value: '+245', label: '🇬🇼 +245' },
    { value: '+55', label: '🇧🇷 +55' },
    { value: '+351', label: '🇵🇹 +351' },
    { value: '+33', label: '🇫🇷 +33' },
    { value: '+49', label: '🇩🇪 +49' },
    { value: '+44', label: '🇬🇧 +44' },
    { value: '+1', label: '🇺🇸 +1' },
    { value: '+34', label: '🇪🇸 +34' },
    { value: '+39', label: '🇮🇹 +39' },
    { value: '+31', label: '🇳🇱 +31' },
    { value: '+32', label: '🇧🇪 +32' },
    { value: '+41', label: '🇨🇭 +41' },
    { value: '+46', label: '🇸🇪 +46' },
    { value: '+47', label: '🇳🇴 +47' },
    { value: '+45', label: '🇩🇰 +45' },
    { value: '+358', label: '🇫🇮 +358' },
    { value: '+43', label: '🇦🇹 +43' },
    { value: '+48', label: '🇵🇱 +48' },
    { value: '+420', label: '🇨🇿 +420' },
    { value: '+36', label: '🇭🇺 +36' },
    { value: '+40', label: '🇷🇴 +40' },
    { value: '+359', label: '🇧🇬 +359' },
    { value: '+385', label: '🇭🇷 +385' },
    { value: '+386', label: '🇸🇮 +386' },
    { value: '+421', label: '🇸🇰 +421' },
    { value: '+370', label: '🇱🇹 +370' },
    { value: '+371', label: '🇱🇻 +371' },
    { value: '+372', label: '🇪🇪 +372' },
    { value: '+7', label: '🇷🇺 +7' },
    { value: '+86', label: '🇨🇳 +86' },
    { value: '+81', label: '🇯🇵 +81' },
    { value: '+82', label: '🇰🇷 +82' },
    { value: '+91', label: '🇮🇳 +91' },
    { value: '+61', label: '🇦🇺 +61' },
    { value: '+64', label: '🇳🇿 +64' },
    { value: '+27', label: '🇿🇦 +27' },
    { value: '+20', label: '🇪🇬 +20' },
    { value: '+234', label: '🇳🇬 +234' },
    { value: '+254', label: '🇰🇪 +254' },
    { value: '+212', label: '🇲🇦 +212' },
    { value: '+213', label: '🇩🇿 +213' },
    { value: '+216', label: '🇹🇳 +216' },
    { value: '+218', label: '🇱🇾 +218' },
    { value: '+220', label: '🇬🇲 +220' },
    { value: '+221', label: '🇸🇳 +221' },
    { value: '+222', label: '🇲🇷 +222' },
    { value: '+223', label: '🇲🇱 +223' },
    { value: '+224', label: '🇬🇳 +224' },
    { value: '+225', label: '🇨🇮 +225' },
    { value: '+226', label: '🇧🇫 +226' },
    { value: '+227', label: '🇳🇪 +227' },
    { value: '+228', label: '🇹🇬 +228' },
    { value: '+229', label: '🇧🇯 +229' },
    { value: '+230', label: '🇲🇺 +230' },
    { value: '+231', label: '🇱🇷 +231' },
    { value: '+232', label: '🇸🇱 +232' },
    { value: '+233', label: '🇬🇭 +233' },
    { value: '+235', label: '🇹🇩 +235' },
    { value: '+236', label: '🇨🇫 +236' },
    { value: '+237', label: '🇨🇲 +237' },
    { value: '+238', label: '🇨🇻 +238' },
    { value: '+239', label: '🇸🇹 +239' },
    { value: '+240', label: '🇬🇶 +240' },
    { value: '+241', label: '🇬🇦 +241' },
    { value: '+242', label: '🇨🇬 +242' },
    { value: '+243', label: '🇨🇩 +243' },
    { value: '+244', label: '🇦🇴 +244' },
    { value: '+246', label: '🇮🇴 +246' },
    { value: '+248', label: '🇸🇨 +248' },
    { value: '+249', label: '🇸🇩 +249' },
    { value: '+250', label: '🇷🇼 +250' },
    { value: '+251', label: '🇪🇹 +251' },
    { value: '+252', label: '🇸🇴 +252' },
    { value: '+253', label: '🇩🇯 +253' },
    { value: '+255', label: '🇹🇿 +255' },
    { value: '+256', label: '🇺🇬 +256' },
    { value: '+257', label: '🇧🇮 +257' },
    { value: '+258', label: '🇲🇿 +258' },
    { value: '+260', label: '🇿🇲 +260' },
    { value: '+261', label: '🇲🇬 +261' },
    { value: '+262', label: '🇷🇪 +262' },
    { value: '+263', label: '🇿🇼 +263' },
    { value: '+264', label: '🇳🇦 +264' },
    { value: '+265', label: '🇲🇼 +265' },
    { value: '+266', label: '🇱🇸 +266' },
    { value: '+267', label: '🇧🇼 +267' },
    { value: '+268', label: '🇸🇿 +268' },
    { value: '+269', label: '🇰🇲 +269' },
    { value: '+290', label: '🇸🇭 +290' },
    { value: '+291', label: '🇪🇷 +291' },
    { value: '+297', label: '🇦🇼 +297' },
    { value: '+298', label: '🇫🇴 +298' },
    { value: '+299', label: '🇬🇱 +299' }
  ];

  // Filtrar DDIs baseado na pesquisa
  const filteredDdiOptions = ddiOptions.filter(option =>
    option.value.includes(ddiSearch) ||
    option.label.toLowerCase().includes(ddiSearch.toLowerCase())
  );

  const handleDdiSelect = (ddi) => {
    setFormData(prev => ({
      ...prev,
      ddi: ddi.value
    }));
    setDdiSearch('');
    setIsDdiDropdownOpen(false);
  };

  // Encontrar a bandeira do DDI selecionado
  const getSelectedDdiFlag = () => {
    const selectedOption = ddiOptions.find(option => option.value === formData.ddi);
    return selectedOption ? selectedOption.label.split(' ')[0] : '🇬🇼';
  };

  const handleDdiSearchChange = (e) => {
    setDdiSearch(e.target.value);
    setIsDdiDropdownOpen(true);
  };

  // Fechar dropdown quando clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ddiDropdownRef.current && !ddiDropdownRef.current.contains(event.target)) {
        setIsDdiDropdownOpen(false);
        setDdiSearch('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Verificar se o CAPTCHA foi resolvido
    if (!isCaptchaVerified) {
      setSubmitStatus('captcha-error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Criar FormData para envio de arquivos
      const formDataToSend = new FormData();

      // Adicionar campos de texto
      formDataToSend.append('pais_id', '1'); // Guiné-Bissau
      formDataToSend.append('nome', formData.nome);
      formDataToSend.append('telefone', `${formData.ddi} ${formData.telefone}`);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('status', 'Pendente');
      formDataToSend.append('area_interesse', formData.cargo);
      formDataToSend.append('experiencia_profissional', formData.experiencia);
      formDataToSend.append('disponibilidade', formData.disponibilidade);
      formDataToSend.append('razao_colaborar', formData.motivacao);

      // Adicionar arquivos se existirem
      if (formData.cv) {
        formDataToSend.append('cv_file', formData.cv);
      }
      if (formData.foto) {
        formDataToSend.append('foto_file', formData.foto);
      }

      const response = await apiService.createCandidato(formDataToSend, true);

      if (response) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          ddi: '+245',
          telefone: '',
          cargo: '',
          experiencia: '',
          disponibilidade: '',
          motivacao: '',
          cv: null,
          foto: null
        });
        // Reset file inputs
        document.getElementById('cv').value = '';
        document.getElementById('foto').value = '';
        setIsCaptchaVerified(false); // Reset CAPTCHA

        // Fechar modal primeiro
        onClose();
        setSubmitStatus(null);

        // Mostrar notificação após o modal fechar completamente
        setTimeout(() => {
          onNotification(response.message || 'Candidato criado com sucesso!', 'success');
        }, 500); // Delay maior para garantir que o modal feche completamente
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
      setSubmitStatus('error');

      // Fechar modal primeiro
      onClose();
      setSubmitStatus(null);

      // Mostrar notificação de erro após o modal fechar completamente
      setTimeout(() => {
        onNotification('Erro ao enviar candidatura. Tente novamente.', 'error');
      }, 500); // Delay maior para garantir que o modal feche completamente
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setSubmitStatus(null);
    setIsCaptchaVerified(false);
    setDdiSearch('');
    setIsDdiDropdownOpen(false);
    setFormData({
      nome: '',
      email: '',
      ddi: '+245',
      telefone: '',
      cargo: '',
      experiencia: '',
      disponibilidade: '',
      motivacao: '',
      cv: null,
      foto: null
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">{t('modalCandidatura.title')}</h2>
              <p className="text-gray-600 mt-1">
                {t('modalCandidatura.subtitle')}
              </p>
            </div>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 text-2xl transition-colors duration-200"
            >
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="px-8 py-6">
          {submitStatus === 'success' && (
            <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
              <div className="flex items-center">
                <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                {t('modalCandidatura.messages.success')}
              </div>
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              <div className="flex items-center">
                <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                {t('modalCandidatura.messages.error')}
              </div>
            </div>
          )}

          {submitStatus === 'captcha-error' && (
            <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              <div className="flex items-center">
                <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                {t('modalCandidatura.messages.captchaError')}
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Informações Pessoais */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                  {t('modalCandidatura.form.fields.nome.label')}
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  value={formData.nome}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                  placeholder={t('modalCandidatura.form.fields.nome.placeholder')}
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  {t('modalCandidatura.form.fields.email.label')}
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                  placeholder={t('modalCandidatura.form.fields.email.placeholder')}
                />
              </div>

              <div>
                <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-2">
                  {t('modalCandidatura.form.fields.telefone.label')}
                </label>
                <div className="flex space-x-2">
                  <div className="relative w-24" ref={ddiDropdownRef}>
                    <div className="relative">
                      <input
                        type="text"
                        value={ddiSearch || formData.ddi}
                        onChange={handleDdiSearchChange}
                        onFocus={() => setIsDdiDropdownOpen(true)}
                        className={`w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200 bg-white text-sm ${ddiSearch ? 'px-3' : 'pl-10 pr-3'}`}
                        placeholder="+245"
                      />
                      {!ddiSearch && (
                        <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                          <span className="text-lg">{getSelectedDdiFlag()}</span>
                        </div>
                      )}
                    </div>
                    {isDdiDropdownOpen && (
                      <div className="absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-lg shadow-lg z-50 max-h-60 overflow-y-auto">
                        {filteredDdiOptions.length > 0 ? (
                          filteredDdiOptions.map((option) => (
                            <div
                              key={option.value}
                              onClick={() => handleDdiSelect(option)}
                              className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm flex items-center"
                            >
                              <span className="mr-2">{option.label.split(' ')[0]}</span>
                              <span>{option.value}</span>
                            </div>
                          ))
                        ) : (
                          <div className="px-3 py-2 text-sm text-gray-500">
                            {t('modalCandidatura.form.fields.telefone.noResults')}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <input
                    type="tel"
                    id="telefone"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleTelefoneChange}
                    required
                    className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                    placeholder={t('modalCandidatura.form.fields.telefone.placeholder')}
                    maxLength="15"
                  />
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  {t('modalCandidatura.form.fields.telefone.help')}
                </p>
              </div>

              <div>
                <label htmlFor="cargo" className="block text-sm font-medium text-gray-700 mb-2">
                  {t('modalCandidatura.form.fields.cargo.label')}
                </label>
                <select
                  id="cargo"
                  name="cargo"
                  value={formData.cargo}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                >
                  <option value="">{t('modalCandidatura.form.fields.cargo.placeholder')}</option>
                  <option value="consultoria">{t('modalCandidatura.form.fields.cargo.options.consultoria')}</option>
                  <option value="pesquisa">{t('modalCandidatura.form.fields.cargo.options.pesquisa')}</option>
                  <option value="conexao">{t('modalCandidatura.form.fields.cargo.options.conexao')}</option>
                  <option value="voluntario">{t('modalCandidatura.form.fields.cargo.options.voluntario')}</option>
                  <option value="outro">{t('modalCandidatura.form.fields.cargo.options.outro')}</option>
                </select>
              </div>
            </div>

            {/* Experiência e Disponibilidade */}
            <div>
              <label htmlFor="experiencia" className="block text-sm font-medium text-gray-700 mb-2">
                {t('modalCandidatura.form.fields.experiencia.label')}
              </label>
              <textarea
                id="experiencia"
                name="experiencia"
                value={formData.experiencia}
                onChange={handleInputChange}
                required
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                placeholder={t('modalCandidatura.form.fields.experiencia.placeholder')}
              />
            </div>

            <div>
              <label htmlFor="disponibilidade" className="block text-sm font-medium text-gray-700 mb-2">
                {t('modalCandidatura.form.fields.disponibilidade.label')}
              </label>
              <select
                id="disponibilidade"
                name="disponibilidade"
                value={formData.disponibilidade}
                onChange={handleInputChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
              >
                <option value="">{t('modalCandidatura.form.fields.disponibilidade.placeholder')}</option>
                <option value="integral">{t('modalCandidatura.form.fields.disponibilidade.options.integral')}</option>
                <option value="meio-periodo">{t('modalCandidatura.form.fields.disponibilidade.options.meio-periodo')}</option>
                <option value="fins-semana">{t('modalCandidatura.form.fields.disponibilidade.options.fins-semana')}</option>
                <option value="voluntario">{t('modalCandidatura.form.fields.disponibilidade.options.voluntario')}</option>
              </select>
            </div>

            {/* Motivação */}
            <div>
              <label htmlFor="motivacao" className="block text-sm font-medium text-gray-700 mb-2">
                {t('modalCandidatura.form.fields.motivacao.label')}
              </label>
              <textarea
                id="motivacao"
                name="motivacao"
                value={formData.motivacao}
                onChange={handleInputChange}
                required
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                placeholder={t('modalCandidatura.form.fields.motivacao.placeholder')}
              />
            </div>

            {/* Upload de Arquivos */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="cv" className="block text-sm font-medium text-gray-700 mb-2">
                  {t('modalCandidatura.form.fields.cv.label')}
                </label>
                <input
                  type="file"
                  id="cv"
                  name="cv"
                  onChange={handleFileChange}
                  accept=".pdf"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                />
                <p className="text-xs text-gray-500 mt-1">{t('modalCandidatura.form.fields.cv.help')}</p>
              </div>

              <div>
                <label htmlFor="foto" className="block text-sm font-medium text-gray-700 mb-2">
                  {t('modalCandidatura.form.fields.foto.label')}
                </label>
                <input
                  type="file"
                  id="foto"
                  name="foto"
                  onChange={handleFileChange}
                  accept="image/*"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                />
                <p className="text-xs text-gray-500 mt-1">{t('modalCandidatura.form.fields.foto.help')}</p>
              </div>
            </div>

            {/* CAPTCHA */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('modalCandidatura.form.fields.captcha.label')}
              </label>
              <Captcha
                onVerify={setIsCaptchaVerified}
                onError={(error) => console.log('CAPTCHA Error:', error)}
              />
            </div>

            {/* Botões */}
            <div className="flex flex-col sm:flex-row gap-4 pt-6">
              <button
                type="button"
                onClick={handleClose}
                className="flex-1 px-6 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 font-semibold rounded-lg transition-colors duration-200"
              >
                {t('modalCandidatura.buttons.cancel')}
              </button>
              <button
                type="submit"
                disabled={isSubmitting || !isCaptchaVerified}
                className={`flex-1 px-6 py-3 text-white font-semibold rounded-lg transition-all duration-200 ${
                  isSubmitting || !isCaptchaVerified
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 shadow-lg hover:shadow-xl'
                }`}
              >
                {isSubmitting ? t('modalCandidatura.buttons.submit.sending') : !isCaptchaVerified ? t('modalCandidatura.buttons.submit.captchaRequired') : t('modalCandidatura.buttons.submit.default')}
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default ModalCandidatura;
